module.exports = __webpack_public_path__ + "img/bellis.f13d0ca9.jpg";